import React from 'react';

const IconAlif = () => {
  return (
    <div>
      <svg
        width="150"
        height="100"
        viewBox="0 0 72 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1070_1248)">
          <path
            d="M34.6752 13.0306C34.6752 13.8117 34.3962 14.4812 33.8941 15.0391C33.3919 15.5971 32.6108 15.8202 31.8297 15.8202C31.0486 15.8202 30.3791 15.5413 29.877 15.0391C29.3748 14.4812 29.1516 13.8117 29.1516 13.0306C29.1516 12.2495 29.4306 11.58 29.877 11.0778C30.3791 10.5199 31.0486 10.2409 31.8297 10.2409C32.6108 10.2409 33.3919 10.5199 33.8941 11.0778C34.3962 11.58 34.6752 12.1937 34.6752 13.0306ZM34.6194 9.29244C33.7825 8.56713 32.7782 8.23237 31.6065 8.23237C30.3233 8.23237 29.0401 8.67872 28.2032 9.57141C27.3105 10.4641 26.9199 11.6358 26.9199 12.9748C26.9199 14.3696 27.3663 15.5413 28.2032 16.434C29.0401 17.3824 30.2675 17.8288 31.6065 17.8288C32.834 17.8288 33.6709 17.494 34.6194 16.7687V17.6056H36.6837V8.39975H34.6194V9.29244Z"
            fill="#222222"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.6923 17.7172C39.8081 17.7172 40.645 17.2709 41.203 16.3224C41.4261 15.9876 41.6493 15.4297 41.7609 15.0949C41.9283 14.7044 42.0399 13.9233 42.1515 13.5885C42.2072 13.4211 42.263 13.1422 42.3188 12.7516L42.4304 11.9705C42.4304 11.8031 42.4862 11.5242 42.542 11.0778L42.6536 10.2967H44.7179V17.6056H46.8939V8.39975H40.7566L40.645 9.12506C40.4777 10.8546 40.2545 12.2495 40.0871 13.198C39.9197 14.1464 39.6966 14.8718 39.306 15.3739C38.9712 15.8202 38.5249 16.0434 37.967 16.0434L38.0786 17.6614C38.3575 17.7172 38.5249 17.7172 38.6923 17.7172Z"
            fill="#222222"
          />
          <path
            d="M66.533 10.1293C68.6532 10.1293 69.8806 11.2452 69.8806 13.0306C69.8806 14.816 68.5974 15.9318 66.533 15.9318V10.1293ZM61.1211 13.0306C61.1211 11.2452 62.3486 10.1293 64.4687 10.1293V15.9318C62.3486 15.876 61.1211 14.816 61.1211 13.0306ZM72.0008 13.0306C72.0008 11.58 71.4986 10.4083 70.4944 9.57141C69.4901 8.67872 68.151 8.23237 66.533 8.17658V5.72168H64.4687V8.17658C62.8507 8.23237 61.4559 8.67872 60.5074 9.57141C59.5031 10.4083 59.001 11.58 59.001 13.0306C59.001 14.4812 59.5031 15.5971 60.5074 16.434C61.5117 17.2709 62.8507 17.773 64.4687 17.8288V20.2837H66.533V17.8288C68.2068 17.773 69.5459 17.3267 70.4944 16.4898C71.4986 15.5971 72.0008 14.4254 72.0008 13.0306Z"
            fill="#222222"
          />
          <path
            d="M50.1299 17.6056L55.3186 11.8589V17.6056H57.4388V8.39975H56.0439L50.911 14.2022V8.39975H48.735V17.6056H50.1299Z"
            fill="#222222"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8437 26.3902C10.0583 26.2229 8.38449 25.7207 6.82228 24.8838C3.86523 23.2658 1.57771 20.5319 0.517633 17.0728C-0.486647 13.6136 0.0154926 10.0428 1.6335 7.14155C3.75365 3.23601 7.82656 0.557933 12.1784 0H12.29L13.4059 2.78967C13.3501 2.78967 13.2943 2.78967 13.2943 2.78967C9.61195 3.01284 5.92959 5.18878 4.1442 8.48059C2.86095 10.7681 2.52619 13.5578 3.3073 16.2359C4.08841 18.9697 5.92959 21.0899 8.21711 22.3173C9.44457 22.9869 10.7836 23.3774 12.1784 23.5448C15.2471 23.8238 18.0925 22.8195 20.3243 21.0341C20.4359 20.9225 20.5474 20.8667 20.659 20.7551L21.7749 23.5448C19.041 25.6091 15.526 26.725 11.8437 26.3902ZM14.8565 6.52782H11.3415L6.71069 17.9655H9.72353L13.1269 9.09431L16.5303 17.9655H19.5432L14.8565 6.52782Z"
            fill="#39B980"
          />
        </g>
        <defs>
          <clipPath id="clip0_1070_1248">
            <rect width="72" height="26.449" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default IconAlif;
